<template>
  <div class="flex flex-col h-full w-full text-yellow-500 bg-yellow-500">
    <div class="heading-container mx-auto">
      <h1 :class="offerHeadingStyle" class="text-red-500 text-5xl font-bold p-4">OFFER #2</h1>
    </div>

    <div class="squares text-center border-black border? container mx-auto h-full 2xl:mt-20">
      <div class="flex flex-col w-full h-full">
        <div class="flex w-full h-red-squares">
          <div class="w-1/2 border py-4 mr-8">
            <div class="red-square animate pop-in animate__delay-1s bg-contain bg-right bg-no-repeat w-full h-full">
              <div class="red-box-left-descriptions pt-4 xl:pt-8 text-xl ml-auto">
                <div class="flex flex-col w-3/4 mx-auto border?">
                  <h2 class="text-3xl animate pop-in animate__delay-5s">1</h2>

                  <div class="number-underline animate pop-in animate__delay-6s w-full border-4 border-yellow-500"></div>
                  <p class="description text-center mt-2 xl:mt-4 leading-tight text-sm tracking-wide animate pop-in animate__delay-7s">Furthering Facebook’s market dominance and superiority over the competition.</p>
                </div>

              </div>
            </div>
          </div>
          <div class="w-1/2 border py-4">
            <div class="red-square animate pop-in animate__delay-2s bg-contain bg-left bg-no-repeat w-full h-full">
              <div class="red-box-right-descriptions pt-4 xl:pt-8 text-xl">
                <div class="flex flex-col w-3/4 mx-auto border?">
                  <h2 class="text-3xl animate pop-in animate__delay-8s">2</h2>

                  <div class="number-underline w-full border-4 border-yellow-500 animate pop-in animate__delay-9s"></div>
                  <p class="description text-center mt-2 xl:mt-4 leading-tight text-sm tracking-wide animate pop-in animate__delay-10s">An overall increase in Users and User-Engagement parameters; alongside the reinforcement of Brand loyalty among the existing User-Demographic.</p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex w-full h-red-squares">
          <div class="w-1/2 border py-4 mr-8">
            <div class="red-square animate pop-in animate__delay-3s bg-contain bg-right bg-no-repeat w-full h-full">
              <div class="red-box-left-descriptions pt-4 xl:pt-8 text-xl ml-auto">
                <div class="flex flex-col w-3/4 mx-auto border?">
                  <h2 class="text-3xl animate pop-in animate__delay-11s">3</h2>

                  <div class="number-underline w-full border-4 border-yellow-500 animate pop-in animate__delay-12s"></div>
                  <p class="description text-center mt-2 xl:mt-4 leading-tight text-sm tracking-wide animate pop-in animate__delay-13s">Increased <br>Advertising <br>Revenue.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2 border py-4">
            <div class="red-square animate pop-in animate__delay-4s bg-contain bg-left bg-no-repeat w-full h-full">
              <div class="red-box-right-descriptions pt-4 xl:pt-8 text-xl">
                <div class="flex flex-col w-3/4 mx-auto border?">
                  <h2 class="text-3xl animate pop-in animate__delay-14s">4</h2>

                  <div class="number-underline w-full border-4 border-yellow-500 animate pop-in animate__delay-15s"></div>
                  <p id="last-animation" class="description text-center mt-2 xl:mt-4 leading-tight text-sm tracking-wide animate pop-in animate__delay-16s">BLISSING is relevant <br>for the present Age, <br>Society & Democracy.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <IntroSkipButton />
  </div>
</template>

<script>
import IntroSkipButton from "@/components/introduction/IntroSkipButton.vue";

export default {
  name: "IntroThirdPage",
  components:{
    IntroSkipButton
  },
  methods:{
    progressForward(){
      Event.$emit('skipIntroForward');
    }
  },
  computed: {
    offerHeadingStyle: function () {
      return {
        'mt-0': window.innerHeight < 900,
        'mt-12': window.innerHeight > 900,
      }
    },
  },
  mounted(){
    const lastAnimation = document.querySelector('#last-animation');

    lastAnimation.addEventListener('animationend', () => {
      setTimeout(() =>{ this.progressForward() }, 3000)
    });

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red-square{
  background-image: url('https://blissing.s3-us-west-1.amazonaws.com/img/block-red.png');
}
.h-red-squares{
  height: 20rem;
}

@media (min-width: 640px){

.h-red-squares {
    height: 20rem;
  }

  .red-box-left-descriptions{
    width: 25.6rem;
    margin-right: 1.6rem;
  }

  .red-box-right-descriptions{
    width: 25.6rem;
    margin-right: 1.6rem;
  }

}

@media (min-width: 768px){

.h-red-squares {
    height: 15rem;
  }

  .red-box-left-descriptions{
    width: 18.6rem;
    margin-right: 1.6rem;
  }

  .red-box-right-descriptions{
    width: 18.6rem;
    margin-right: 1.6rem;
  }

}

@media (min-width: 1024px){

.h-red-squares {
    height: 15rem;
  }

  .red-box-left-descriptions{
    width: 18.6rem;
    margin-right: 1.6rem;
  }

  .red-box-right-descriptions{
    width: 18.6rem;
    margin-right: 1.6rem;
  }

}

@media (min-width: 1280px){

.h-red-squares {
    height: 15rem;
  }

  .description{
    font-size: 0.875rem;
  }

  .red-box-left-descriptions{
    width: 18.4rem;
    margin-right: 1.6rem;
  }

  .red-box-right-descriptions{
    width: 18.4rem;
    margin-right: 1.6rem;
  }

}

@media (min-width: 1367px){

.h-red-squares {
    height: 17rem;
  }

  .description{
    font-size: 1.125rem;
  }

  .red-box-left-descriptions{
    width: 21.4rem;
    margin-right: 1.6rem;
  }

  .red-box-right-descriptions{
    width: 21.4rem;
    margin-right: 1.6rem;
  }

}

@media (min-width: 1920px){

  .h-red-squares {
      height: 20rem;
    }

  .red-box-left-descriptions{
    width: 25.6rem;
    margin-right: 1.6rem;
  }

  .description{
    font-size: 1.125rem;
  }

  .red-box-right-descriptions{
    width: 25.6rem;
    margin-right: 1.6rem;
  }

}

</style>
